import React from 'react';
import { Spin } from 'antd';

const spinnerStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  height: '100vh',
  width: '100vw',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
};

const FullscreenSpinner = ({ isLoading, tip }) => {
  return isLoading ? (
    <div style={spinnerStyle}>
      <Spin tip={tip} size="large" />
    </div>
  ) : null;
};

export default FullscreenSpinner;
